import { render, staticRenderFns } from "./selUserPerm.vue?vue&type=template&id=52e3fa02&"
import script from "./selUserPerm.vue?vue&type=script&lang=js&"
export * from "./selUserPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports